// Улаанбаатар хотын дүүрэг ба хороодын тоо.
// khoroos = тухайн дүүргийн хороодын нийт тоо (сонголтод 1..N хороо гаргана).
export interface DistrictInfo {
  name: string;
  khoroos: number;
}

export const UB_DISTRICTS: DistrictInfo[] = [
  { name: 'Багануур', khoroos: 5 },
  { name: 'Багахангай', khoroos: 2 },
  { name: 'Баянгол', khoroos: 25 },
  { name: 'Баянзүрх', khoroos: 43 },
  { name: 'Налайх', khoroos: 8 },
  { name: 'Сонгинохайрхан', khoroos: 43 },
  { name: 'Сүхбаатар', khoroos: 20 },
  { name: 'Хан-Уул', khoroos: 25 },
  { name: 'Чингэлтэй', khoroos: 24 },
];

export function khorooOptions(districtName: string): string[] {
  const d = UB_DISTRICTS.find(x => x.name === districtName);
  if (!d) return [];
  return Array.from({ length: d.khoroos }, (_, i) => `${i + 1}-р хороо`);
}
